if (!customElements.get('meals-slider')) {
  class MealsSlider extends HTMLElement {
    connectedCallback() {
      const sliderEl = this.querySelector('[data-swiper]');
      const prevEl = this.querySelector('[data-prev]');
      const nextEl = this.querySelector('[data-next]');

      if (!sliderEl || !window.Swiper) return;

      this.swiper = new window.Swiper(sliderEl, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 500,
        navigation: {
          prevEl,
          nextEl
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        },
        on: {
          init: () => this.updateNavState(),
          slideChange: () => this.updateNavState(),
          resize: () => this.updateNavState()
        }
      });

      this.updateNavState();
    }

    updateNavState() {
      if (!this.swiper) return;

      const prevEl = this.querySelector('[data-prev]');
      const nextEl = this.querySelector('[data-next]');

      if (prevEl) {
        prevEl.classList.toggle('is-hidden', this.swiper.isBeginning);
      }

      if (nextEl) {
        nextEl.classList.toggle('is-hidden', this.swiper.isEnd);
      }
    }
  }

  customElements.define('meals-slider', MealsSlider);
}
